<a
    clButton
    [routerLink]="routerLink()"
    [severity]="severity() ?? 'primary'"
    [variant]="variant() ?? 'filled'"
    [clSize]="size() ?? 'normal'"
    [rounded]="rounded()"
    [iconOnly]="iconOnly()"
    [class.icon-only]="iconOnly()"
    [attr.aria-label]="ariaLabel()"
>
    <ng-content />
</a>
